import React from 'react';
import { X } from 'lucide-react';
import MetricsPanel from './MetricsPanel';
import SessionStatusBadge from './SessionStatusBadge'; // 🎟️ TICKET P0

export default function MetricsDrawer({ 
  open, 
  onClose, 
  sessionMetrics, 
  agent,
  sessionStatusAfter,
  dataSource, // 🎟️ V4-P0-008: Objeto completo de sesión
  moderatorAlert, // 🎟️ V4-P0-008: Alerta del moderador
  currentPhase,
  currentPhaseDisplayName,
  turnsInPhase,
  isAdmin = false // 🎟️ V4-P0-007: Admin-only MetricsPanel
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-end">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/35 transition-opacity"
        aria-hidden="true"
        onClick={onClose}
      />
      {/* Drawer panel */}
      <div className="relative bg-white w-full max-w-[420px] min-w-[min(92vw,420px)] h-[100dvh] shadow-2xl flex flex-col animate-slideInRight">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <span className="font-semibold text-lg">Métricas de sesión</span>
          <button
            type="button"
            className="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            aria-label="Cerrar"
            onClick={onClose}
          >
            <X className="w-5 h-5 text-gray-700" />
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-auto p-4 space-y-4">
          {/* 🎟️ TICKET P0: Visualización de estado Motor V4 - P0 BUG FIX */}
          {/* 🎟️ P0 BUG FIX: Calcular phaseConfig con datos del backend */}
          {(() => {
            const currentPhaseData = agent?.stateMachine?.phases?.find(
              p => p.phaseId === currentPhase || p.id === currentPhase
            );
            
            // 🎟️ P0 BUG FIX: Priorizar datos del backend sobre agent local
            const phaseConfig = {
              // Del backend (fuente de verdad si existe)
              phaseMinTurns: sessionMetrics?.phase?.phaseMinTurns || currentPhaseData?.minTurns || 1,
              phaseMaxTurns: sessionMetrics?.phase?.phaseMaxTurns || currentPhaseData?.maxTurns || 3,
              phaseJustTransitioned: sessionMetrics?.phase?.phaseJustTransitioned || false,
              
              // Legacy support (mantener por compatibilidad)
              minTurns: sessionMetrics?.phase?.phaseMinTurns || currentPhaseData?.minTurns || 1,
              maxTurns: sessionMetrics?.phase?.phaseMaxTurns || currentPhaseData?.maxTurns || 3
            };
            
            return (
              <SessionStatusBadge
                sessionStatus={sessionStatusAfter}
                dataSource={dataSource}
                moderatorAlert={moderatorAlert}
                currentPhase={currentPhase}
                currentPhaseDisplayName={currentPhaseDisplayName}
                phaseConfig={phaseConfig}
                turnsInPhase={turnsInPhase}
                maxTurns={sessionMetrics?.maxTurns || 0}
                completedTurns={sessionMetrics?.completedTurns || 0}
              />
            );
          })()}
          
          {/* 🎟️ V4-P0-007: MetricsPanel solo visible para admin */}
          {isAdmin && (
            <MetricsPanel 
              sessionMetrics={sessionMetrics}
              agent={agent}
              agentPhases={agent?.stateMachine?.phases || []}
            />
          )}
        </div>
      </div>
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slideInRight {
          animation: slideInRight 0.25s cubic-bezier(0.4,0,0.2,1);
        }
      `}</style>
    </div>
  );
}
